{
  "title": {
    "selectKind": "发起申诉",
    "details": "申诉原因",
    "amountMismatch": "金额不符"
  },
  "submitButton": {
    "selectKind": "下一步",
    "details": "确认",
    "amountMismatch": "申请修改金额"
  },
  "selectKind": {
    "title": "申诉类型",
    "options": {
      "UploadPaymentProofFailed": "上传不了图片",
      "BankInfoError": "银行卡转不过去",
      "WechatInfoError": "微信二维码扫不过去",
      "AlipayInfoError": "支付宝二维码扫不过去",
      "QQInfoError": "QQ二维码扫不过去",
      "SellerDidNotConfirm": "卖家不放币",
      "CannotConfirmBuyerPaymentProof": "收款账户出现异常-无法确认",
      "AmountMismatch": "金额不符",
      "SellerNotReceivedPayment": "未收到款",
      "Other": "其他"
    }
  },
  "details": {
    "title": "申诉原因",
    "placeholder": "请填写申诉原因",
    "uploadImage": "上传照片",
    "uploadImageTip": "上传 1 至 3 张图片，每张不超过 5MB，支持 JPG、JPEG、PNG。",
    "submitFailed": "提交失败",
    "maxCharacters": "字数超过了 800 字的限制。",
    "modal": {
      "title": "确认发起申诉",
      "content": "发起申诉后，客服将介入本次交易，直至申诉结束。",
      "cancel": "取消",
      "confirm": "确认申诉"
    }
  },
  "amountMismatch": {
    "description": "若您发现收到的金额与预期不符，请在下方输入您实际收到的金额。买家同意后，订单会修改成您输入的金额，也会更新相应的{{token}}交易数量。",
    "estimatedAmount": "预计获得",
    "actualAmount": "实收金额",
    "placeholder": "请填写申请修改金额",
    "uploadImage": "上传交易凭证",
    "uploadImageTip": "上传 1 至 3 张图片，每张不超过 5MB，支持 JPG、JPEG、PNG。",
    "amountExceedsRemaining": "增加的金额超过了原挂单的剩余数量，请重新输入",
    "changeInProgress": "当前订单所属的卖币挂单下，已经有另一笔交易订单正在修改金额。暂时无法进行此订单的金额修改操作，请稍后再试。",
    "exceedsOriginal": "如果要修改的数量超过原本订单的交易数量，请点申诉",
    "limitTitle": "金额修改限制"
  },
  "back": "上一步",
  "SellerNotReceivedPayment": {
    "description": "请录制并上传网银流水视频（需清楚录制当前北京时间）。\n您可以按照以下步骤操作：打开应用商店 > 搜索并开启网银APP > 卡信息 > 交易明细。"
  }
}
